'use client';

import dynamic from 'next/dynamic';

const CurrencyDashboard = dynamic(
  () => import('../components/main-chart/CurrencyDashboard').then((m) => m.CurrencyDashboard),
  {
    ssr: false,
    loading: () => (
      <div className="text-center py-10 text-gray-400">Загрузка графика...</div>
    ),
  },
);

export function CurrencyDashboardClient() {
  return <CurrencyDashboard />;
}
